import one from '../assets/svg/project/verity-logo.jpg'
import two from '../assets/svg/project/workdesk-logo.jpg'
import three from '../assets/svg/project/zreya-logo.jpg'
import four from '../assets/svg/project/wersel-logo.jpg'
import five from '../assets/svg/project/sr-logo.jpg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Verity',
        projectDesc: 'A healthcare platform that stores and manages sensitive healthcare data in a secure and compliant manner',
        tags: ['React Js', 'Redux', 'Express Js', 'MongoDB'],
        image: one,
        code: '',
        demo: '',
        contribution: ["Developed the user interface using ReactJS to create a seamless experience for the end-users.",
            "Utilized Redux to manage the app's state and enable the app to operate smoothly and consistently.",
            "Developed and maintained the microservices that make up the backend of the application, using technologies such as Node.js and Express to create a robust and scalable web application that could handle a large amount of traffic and data.",
            "Utilized modern front-end development tools, such as Webpack and Babel, to improve the app's performance and ensure cross-browser compatibility.",
            "Employed MongoDB as the database to store and manage healthcare data and integrate it with Mongoose to make it easier to work with MongoDB.",
            "Developed various command-line utility processes using NodeJS and MongoDB to automate repetitive tasks and improve the app's efficiency.",
            "Integrated AWS S3 bucket to store and retrieve files, images, and other data, improving the app's functionality and user experience.",
            "Ensured the app was compliant with the latest healthcare regulations and data privacy laws.",
            "Implemented various security measures to protect users' sensitive healthcare data and maintain HIPAA compliance.",
            "Optimized the app's performance and scalability to handle the increasing number of users and data.",
            "Implemented a testing strategy to ensure the app was bug-free, efficient, and delivered high-quality results.",
            "Wrote and maintained unit tests for all of the code that you write.",
            "Utilized AWS for version control, and Agile methodologies for development.",
            "Continuously learning new technologies and best practices to stay current with industry developments.",
            "Troubleshooting and resolving any software defects that came up during development.",]
    },
    {
        id: 2,
        projectName: 'Wersel Workdesk',
        projectDesc: "A collaborative platform that helps businesses manage data, people, and projects for growth. Offers easy-to-use tools for collaboration, search, visualization, blockchain, and data security to build a data-driven organization.",
        tags: ['React Js', 'Redux', 'Material UI', 'CSS'],
        image: two,
        code: '',
        demo: '',
        contribution: ["Utilized React JS with Material UI to build a responsive and interactive user interface that allows users to interact with the platform seamlessly.",
            "Implemented Redux to manage the application's state, ensuring that it is always in sync with the server-side data, providing consistency throughout the application.",
            "Leveraged chart and map libraries to enable businesses to visualize and interpret data in real-time, allowing users to quickly identify trends and patterns to make informed decisions.  ",
            "Designed and developed dynamic components that allow users to interact with the platform in a meaningful way.",
            "Ensured that the front-end and back-end functionalities work together seamlessly, providing a cohesive and integrated platform.",
            "Optimized the application for performance, ensuring that it is fast and responsive, regardless of the number of users accessing the platform.",
            "Conducted rigorous testing to ensure that the application is free from bugs and errors, providing a seamless user experience.",
            "Worked closely with the development team to ensure that the front-end and back-end functionalities are aligned and work together seamlessly, providing a cohesive and integrated platform.",]
    },
    {
        id: 3,
        projectName: 'Zreya WebApp',
        projectDesc: 'The application features a responsive interface for managing products and user data via back-end APIs. It includes an admin panel and Mapbox integration to display product locations.',
        tags: ['React Js', 'Redux', 'Material UI', 'CSS'],
        image: three,
        code: '',
        demo: '',
        contribution: ["Developed a responsive user interface using React JS, ensuring that it provides a seamless user experience across all devices.",
            "Managed state with Redux for handling user authentication, form submissions, and API calls.",
            "Integrated with back-end APIs to fetch and update data for products and user information.",
            "Implemented an admin panel with different access levels to manage products and user data.",
            "Integrated a Mapbox library to display product locations and allow users to view nearby products in map view.",
            "Optimized application performance by 30% and reduced data issues by 98%, significantly improving the customer's experience.",]
    },
    {
        id: 4,
        projectName: 'Wersel Website',
        projectDesc: "The application is a static website built with React and Gatsby JS that provides a fast user experience. The website's data is managed through GraphQL, and the user interface reflects the company's brand and vision.",
        tags: ['React Js', 'Gatsby Js', 'GraphQL', 'Material UI'],
        image: four,
        code: '',
        demo: 'https://wersel.io/',
        contribution: ["Collaborated with designers and other developers to create a user interface that reflects the company's brand and vision.",
            "Build the website's UI using reusable React components and Gatsby JS to create a static website that loads quickly and provides a fast user experience.",
            "Used GraphQL to manage the website's data such as product listings, job openings, and company information.",
            "Wrote optimized and efficient code to ensure the website runs smoothly, using techniques such as code-splitting and lazy-loading, optimizing images, and reducing page load time.",
            "Implemented SEO best practices, including metadata, sitemaps, and structured data, to improve website visibility and ranking on search engines.",
            "Used analytics tools such as Google Analytics to track website performance and user behavior, identifying areas for improvement and optimizing website conversion rates.",]
    },
    {
        id: 5,
        projectName: 'SR Resort Website',
        projectDesc: 'The application is a website for a resort that allows customers to search and book rooms. ',
        tags: ['React Js', 'Redux', 'Material UI', 'CSS'],
        image: five,
        code: '',
        demo: '',
        contribution: ["Collaborated with designers to create wireframes and UI designs that reflect the resort's branding and customer needs.",
            "Build the website's user interface using reusable React components, such as search filters, room listings, and booking forms.",
            "Used Redux to manage the website's state, handling actions such as search filters, room selection, and payment processing.",
            "Integrated with backend APIs using Axios to fetch and update data such as room availability, pricing, customer information and also integrated payment gateways foe making transactions.",
            "Wrote optimized and efficient code to ensure the website runs smoothly and provides a fast user experience, using techniques such as code-splitting and lazy-loading of images.",
            "Used testing tools such as Jest and Enzyme to identify and fix bugs, and ensure the website is stable and reliable.",]
    },
    // {
    //     id: 6,
    //     projectName: 'Uber Lite',
    //     projectDesc: 'Uber clone',
    //     tags: ['Flutter'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: six
    // },
    // {
    //     id: 7,
    //     projectName: 'Stock Market App',
    //     projectDesc: 'A simple stock market API app',
    //     tags: ['React', 'Redux', 'Bootstrap'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: seven
    // },
    // {
    //     id: 8,
    //     projectName: 'Car Pooling System',
    //     projectDesc: 'The carpooling system merges multiple people in a car which leads to meet new people, reduces pollution',
    //     tags: ['Flutter', 'React'],
    //     code: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     demo: 'https://github.com/hhhrrrttt222111/developer-portfolio',
    //     image: eight
    // },
]
